<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; gap: 20px;">
  <div></div>
  <div style="display: flex; flex-direction: row; gap: 20px;">
    <div></div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
      <!--Case Detail Toolbar-->
      <mat-toolbar color="primary" class="toolbar-over-card">
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
          <mat-card-title>Case Information</mat-card-title>
        </div>
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center; margin-bottom: 8px;">
          <button mat-icon-button matTooltip="More...." [matMenuTriggerFor]="caseMenu"><mat-icon>more_vert</mat-icon></button>
          <mat-menu #caseMenu="matMenu">
            <button mat-menu-item id="access-case-button" *inRole="[roles.GlobalAccountAdvancedFeatureSet, roles.ProfessionalServices]" (click)="accessCase()"><mat-icon>person_add</mat-icon> Access Case </button>
            <button mat-menu-item id="synchronize-case-index-button" *inRole="[roles.OperationsExpertFeatureSet, roles.Administrator]" (click)="synchronizeCaseIndex()"><mat-icon class="fa-solid fa-rotate-exclamation"></mat-icon>Synchronize Case Index </button>
            <button mat-menu-item id="reshard-case-button" *inRole="[roles.Administrator]" (click)="reshardCaseIndex()"><mat-icon class="fa-solid fa-rotate-right"></mat-icon> Re-Shard Case Index </button>
            <button mat-menu-item id="config-case-button" *inRole="[roles.OperationsExpertFeatureSet, roles.Operations, roles.Developer]" (click)="configCase()"><mat-icon>settings</mat-icon> Case Configuration </button>
            <button mat-menu-item id="manage-user-access-button" *inRole="[roles.GlobalAccountAdvancedFeatureSet, roles.Administrator, roles.Operations]" (click)="manageUserAccess()"><mat-icon>group_add</mat-icon> Manage User Access </button>
          </mat-menu>
        </div>
      </mat-toolbar>
      <!--Case Detail Content-->
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <mat-card appearance="outlined" *ngIf="selectedCase">
          <mat-card-content>
            <form [formGroup]="caseForm">
              <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 49%">
                  <div>
                    <div>
                      <mat-label class="title">Case Guid</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{selectedCase.caseId}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Account</mat-label>
                    </div>
                    <a *ngIf="caseRefreshed" [attr.id]="'goToAdminAccounts.'+selectedCase.accountId" [routerLink]="['/admin/accounts']" [queryParams]="{accountId:selectedCase.accountId}">{{selectedCase.account.accountName}}</a>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Admin Users</mat-label>
                    </div>
                    <a *ngIf="caseRefreshed" [attr.id]="'goToAdminUsers.'+selectedCase.caseId" [routerLink]="['/admin/users']" [queryParams]="{caseId:selectedCase.caseId}">{{selectedCase.users.length}}</a>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
              </div>
              <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 25%">
                  <div>
                    <div>
                      <mat-label class="title">Created By</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{selectedCase.createdBy.userName}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 25%">
                  <div>
                    <div>
                      <mat-label class="title">Created Date</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{selectedCase.dateTimeCreated | date: 'MM/dd/yyyy h:mm a'}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 25%">
                  <div>
                    <div>
                      <mat-label class="title">Case Doc Count</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{selectedCase.caseDocCount}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 25%">
                  <div>
                    <div>
                      <mat-label class="title">Index Doc Count</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{selectedCase.indexDocCount}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="row divider" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Doc Size (Bytes)</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{selectedCase.docSize | number}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Production Job Size (Bytes)</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{selectedCase.productionJobSize | number}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Archive Job Size (Bytes)</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{selectedCase.archiveJobSize | number}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Briefcase Job Size (Bytes)</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{selectedCase.downloadSize | number}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Index Size (Bytes)</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{selectedCase.indexSize | number}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Total Size (Bytes)</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{selectedCase.docSize + selectedCase.productionJobSize + selectedCase.archiveJobSize + selectedCase.downloadSize + selectedCase.indexSize | number}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
              </div>
              <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Doc Size (GB)</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{convertToGB(selectedCase.docSize)}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Production Job Size (GB)</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{convertToGB(selectedCase.productionJobSize)}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Archive Job Size (GB)</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{convertToGB(selectedCase.archiveJobSize)}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Briefcase Job Size (GB)</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{convertToGB(selectedCase.downloadSize)}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Index Size (GB)</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{convertToGB(selectedCase.indexSize)}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div>
                    <div>
                      <mat-label class="title">Total Size (GB)</mat-label>
                    </div>
                    <div *ngIf="caseRefreshed">{{convertToGB(selectedCase.docSize + selectedCase.productionJobSize + selectedCase.archiveJobSize + selectedCase.downloadSize + selectedCase.indexSize)}}</div>
                    <div class="gradient" *ngIf="!caseRefreshed"><br /></div>
                  </div>
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="row divider" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Case Name</mat-label>
                    <input matInput placeholder="Case Name" formControlName="caseName">
                    <mat-error *ngIf="caseForm.controls['caseName'].invalid && (caseForm.controls['caseName'].touched || caseForm.controls['caseName'].dirty)">
                      <p *ngIf="caseForm.controls['caseName'].errors.required">Name is <strong>required</strong></p>
                      <p *ngIf="caseForm.controls['caseName'].errors.maxlength">Name can not exceed <strong>256</strong> characters.</p>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Simple Case Id</mat-label>
                    <input matInput placeholder="Simple Case Id" formControlName="simpleCaseId">
                    <mat-error *ngIf="caseForm.controls['simpleCaseId'].invalid && (caseForm.controls['simpleCaseId'].touched || caseForm.controls['simpleCaseId'].dirty)">
                      <p *ngIf="caseForm.controls['simpleCaseId'].errors.required">Name is <strong>required</strong></p>
                      <p *ngIf="caseForm.controls['simpleCaseId'].errors.maxlength">Name can not exceed <strong>50</strong> characters.</p>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Comments</mat-label>
                    <textarea matInput cdkTextareaAutosize placeholder="Comments" rows="4" formControlName="caseComments"></textarea>
                  </mat-form-field>
                </div>
              </div>
              <div>
                <mat-divider *inRole="[roles.Administrator]"></mat-divider>
                <div class="row divider" *inRole="[roles.Administrator]" style="box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px; place-content: end space-between; align-items: end; ">
                  <div style="flex: 1 1 0%; box-sizing: border-box;">
                    <div>
                      <div>
                        <mat-label class="title">Primary Shard Count</mat-label>
                      </div>
                      <div *ngIf="caseShardsRefreshed">{{selectedCaseShard.primaryShardCount | number}}</div>
                      <div class="gradient" *ngIf="!caseShardsRefreshed"><br /></div>
                    </div>
                  </div>
                  <div style="flex: 1 1 0%; box-sizing: border-box;">
                    <div>
                      <div>
                        <mat-label class="title">Replica Shard Count</mat-label>
                      </div>
                      <div *ngIf="caseShardsRefreshed">{{selectedCaseShard.replicaShardCount | number}}</div>
                      <div class="gradient" *ngIf="!caseShardsRefreshed"><br /></div>
                    </div>
                  </div>
                  <div style="flex: 1 1 0%; box-sizing: border-box;">
                    <div>
                      <div>
                        <mat-label class="title"># of Replica / # of Primary</mat-label>
                      </div>
                      <div *ngIf="caseShardsRefreshed">{{selectedCaseShard.replicaPerPrimary  | number}}</div>
                      <div class="gradient" *ngIf="!caseShardsRefreshed"><br /></div>
                    </div>
                  </div>
                  <div style="flex: 1 1 0%; box-sizing: border-box;">
                    <div>
                      <div>
                        <mat-label class="title">Average Primary Shard Size (GB)</mat-label>
                      </div>
                      <div *ngIf="caseShardsRefreshed">{{convertToGB(selectedCaseShard.avgPrimaryBytes)}}</div>
                      <div class="gradient" *ngIf="!caseShardsRefreshed"><br /></div>
                    </div>
                  </div>
                  <div style="flex: 1 1 0%; box-sizing: border-box;">
                    <div>
                      <div>
                        <mat-label class="title">Average Replica Shard Size (GB)</mat-label>
                      </div>
                      <div *ngIf="caseShardsRefreshed">{{convertToGB(selectedCaseShard.avgReplicaBytes)}}</div>
                      <div class="gradient" *ngIf="!caseShardsRefreshed"><br /></div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </mat-card-content>
          <mat-card-actions *ngIf="canEditCase()">
            <div style="flex: 1 1 0%; box-sizing: border-box;">
              <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
                <button mat-button id="delete-case-button" color="primary" type="button" (click)="delete()">Delete</button>
              </div>
              <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center;">
                <button mat-button id="submit-case-form-button" color="primary" type="submit" [disabled]="caseForm.pristine" (click)="update()">Update</button>
                <button mat-button id="cancel-case-form-button" color="primary" type="reset" [disabled]="caseForm.pristine" (click)="cancel()">Cancel</button>
              </div>
            </div>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
    <div></div>
  </div>
  <div></div>
</div>
